import React, { useEffect, useState } from "react";
import classes from "./styles.module.scss";
import { FaArrowUp } from "react-icons/fa";

const GoToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  const listenToScroll = () => {
    let heightToHidden = 250;
    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop;

    if (winScroll > heightToHidden) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", listenToScroll);
    return () => window.removeEventListener("scroll", listenToScroll);
  }, []);

  const goToBtn = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  return (
    <div className={classes.wrapper}>
      {isVisible && (
        <div className={classes.topbtn} onClick={goToBtn}>
          <FaArrowUp className={classes.topbtnicon} />
        </div>
      )}
    </div>
  );
};

export default GoToTop;
